import {Action} from '@ngrx/store';
import {Pruefplan} from '../../../../clients/qschecks';

export const PAGE_STATE_RESET = '[QschecksControllingFilterModal] Page State reset';
export const REFRESH_DATA = '[QschecksControllingFilterModal] Daten erneut laden';

export const AKTUELLEN_PRUEFPLAN_SETZEN = '[QschecksControllingFilterModal] Aktuellen Pruefplan setzen';
export const AKTUELLE_PRUEFPLAN_ID_SETZEN = '[QschecksControllingFilterModal] Aktuelle PruefplanId setzen';
export const FUNKTIONSBEREICH_PRUEFPLAENE_LADEN = '[QschecksControllingFilterModal] Funktionsbereich Prüfpläne laden';


// PAGE STATE RESET
export class PageStateResetAction implements Action {
    readonly type = PAGE_STATE_RESET;

    constructor() {
    }
}


export class RefreshDataAction implements Action {
    readonly type = REFRESH_DATA;

    constructor() {
    }
}

export class AktuellenPruefplanSetzenAction implements Action {
    readonly type = AKTUELLEN_PRUEFPLAN_SETZEN;

    constructor(public payload: Pruefplan) {
    }
}

export class AktuellePruefplanIdSetzenAction implements Action {
    readonly type = AKTUELLE_PRUEFPLAN_ID_SETZEN;

    constructor(public payload: string) {
    }
}

export class FunktionsbereichPruefplaeneLadenAction implements Action {
    readonly type = FUNKTIONSBEREICH_PRUEFPLAENE_LADEN;

    constructor() {
    }
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
    PageStateResetAction
    | RefreshDataAction
    | AktuellenPruefplanSetzenAction
    | AktuellePruefplanIdSetzenAction
    | FunktionsbereichPruefplaeneLadenAction
    ;
